function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1436 11.247L10.6979 7.63722H7.23258V5.29474C7.23258 4.30718 7.71665 3.34454 9.26864 3.34454H10.844V0.271219C10.844 0.271219 9.4144 0.0273438 8.04755 0.0273438C5.19379 0.0273438 3.32843 1.75626 3.32843 4.88607V7.63721H0.15625V11.247H3.32843V19.9734H7.23257V11.247L10.1436 11.247Z",
  fill: "white"
});
function SvgFacebookF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookF);
export default __webpack_public_path__ + "static/media/facebook-f.db708ded21776d3381457d420624fb8c.svg";
export { ForwardRef as ReactComponent };